import React from 'react'
import { RxCross2 } from 'react-icons/rx'

export default function NavClose({ toggleDrawer }) {
    return (
        <div
            onClick={toggleDrawer}
            className="text-white text-4xl flex justify-end"
        >
            <RxCross2 className="h-6 w-6 text-black" />
        </div>
    )
}

